var lib_core         = require("lib-core");
var lib_geometry     = require("lib-geometry");

var jquerysvg        = require('jquerysvg');
var jquerymousewheel = require('jquery-mousewheel');

var LayerInfo   = require("./../../view/layerInfo.js");
var GroupInfo   = require("./../../view/groupInfo.js");
var RootGroup   = require("./../../view/rootGroup.js");

/**
 * @constructor
 * @param {jQuery}                  parentTemplate
 * @param {lib_core.Collections.HashMap}     layers
 */

var Editor2DView = function (parentTemplate, config, root, stateMachine, editorModel, layers, layerOptions, heavyHandler) {
    var self = this;

    this.root               = root;
    this.config             = config;
    this.stateMachine       = stateMachine;
    this.editorModel        = editorModel;
    this.data               = root.data;
    this.heavyHandler       = heavyHandler;

    // PARENT TEMPLATE
    this.parentTemplate = parentTemplate;

    // INIT JQUERY SVG
    if(this.editorModel.showUI()) {
        this.getTemplate().getCanvasEl().svg();
        this.svg = this.getTemplate().getCanvasEl().svg('get');
    } else {
        var container = "<thumbnail></thumbnail>";
        this.editorModel.thumbnailCanvas($(container));
        this.editorModel.thumbnailCanvas().svg();
        this.svg = this.editorModel.thumbnailCanvas().svg('get');
    }
    this.svg.configure({"xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink"});
    this.svg.configure({height: '100%', width:'100%'}, false);

    this.zoomGroup = this.svg.group();
    this.svg.change(this.zoomGroup, {
        'transform' : 'scale(1,1) translate(0,0)'
    });

    // FILL OUR CONTAINERS
    this.initLayers(layers, layerOptions);

    // BIND OUR EVENT LISTENERS
    if(this.editorModel.showUI() && !this.config.disableMouse)
        this.initEventListeners();

    // DISABLE RIGHT CLICK
    if (this.editorModel.showUI() && !this.config.disableMouse) {
        this.getTemplate().getCanvasEl().bind('contextmenu',function(){return false;});
    }

    // LOAD SYMBOL DATA
    this.loadData();

    // FOR DEBUGGING ONLY
    if(this.editorModel.showUI()) {
        if (window["debug"]) {
            window["gui"] = this;
        }
    }
        
    if(this.editorModel.showUI()) {
        $(window).resize(function(event){
            self.onResize();
        });
    }


};

module.exports = Editor2DView;

Editor2DView.prototype.onResize = function() {
    var cEvent = new lib_core.GuiEvent()
        .type( lib_core.GuiEvents.CANVAS_RESIZE );

    cEvent.element("editorModel", this.editorModel);
    cEvent.data("bb", this.getEditorSize());

    this.stateMachine.handle(cEvent);
};

Editor2DView.prototype.getTemplate = function () {
    if(!this._template && this.editorModel.showUI()){
        this._template = this.parentTemplate.addEditorHolderTemplate();
    }

    return this._template;
};

Editor2DView.prototype.initLayers = function (layers, layerOptions) {
    var self = this;
    this.layers = new lib_core.Collections.HashMap();

    for (var l in layers) {
        this.layers.put(layers[l], new LayerInfo(
                    layers[l], //index
                    false, //visible
                    null, // name
                    null //svgGroup
                    ));
    }

    this.groupInfos = this.createGroupInfos(layers);

    self.layers.forEach(function(index,layerInfo){
        layerInfo.svgGroup = self.svg.group(self.zoomGroup, layerInfo.name);
    });

    if(layerOptions){
        for (var i = 0; i < layerOptions.length; i++) {
            var layerOptionsForOneLayer = layerOptions[i];
            var layerId = layerOptionsForOneLayer[0];
            var layer = this.layers.get(layerId);
            var layerOptionsMapForOneLayer = layerOptionsForOneLayer[1];

            if(layerOptionsMapForOneLayer.svg && layerOptionsMapForOneLayer.svg.opacity)
                layer.opacity = layerOptionsMapForOneLayer.svg.opacity;

            for (var layerOptionKey in layerOptionsForOneLayer[1]) {
                if(layerOptionKey !== 'svg') {
                    layer[layerOptionKey] = layerOptionsMapForOneLayer[layerOptionKey];
                } else {
                    var group = layer.svgGroup;
                    this.svg.change(group, layerOptionsMapForOneLayer[layerOptionKey]);
                }
            }
        }
    }
};

Editor2DView.prototype.initEventListeners = function () {
    var self = this;
    this.mousedown_flag = false;

    // EDITOR CONTAINER OBSERVERS
    this.parentTemplate.$el.mousedown(function(event) {
        return self.onEditorMouseDown(event);
    });

    this.parentTemplate.$el.mousemove(function(event){
        return self.onEditorMouseMove(event);
    });

    this.parentTemplate.$el.mouseup(function(event){
        return self.onEditorMouseUp(event);
    });

    // SVG EVENT LISTENERS
    this.getTemplate().getCanvasEl().mousedown(function(event) {
        return self.onCanvasMouseDown(event);
    });

    this.getTemplate().getCanvasEl().mouseup(function(event){
        return self.onCanvasMouseUp(event);
    });

    this.getTemplate().getCanvasEl().mousewheel(function(objEvent, delta, deltaX, deltaY){
        return self.onCanvasMouseWheel(objEvent, delta, deltaX, deltaY);
    });

    // TOUCH EVENTS
    function msieversion() {
        var ua = window.navigator.userAgent;
        var old_ie = ua.indexOf('MSIE ');
        var new_ie = ua.indexOf('Trident/');

        if ((old_ie > -1) || (new_ie > -1)) {
            return true;
        }else{
            return false;
        }
    }

    if(window.navigator.msPointerEnabled && msieversion() ){
        // TODO: to be updated
        // Hammer(this.getTemplate().getCanvasEl().get(0)).on("transformstart", function(event) {
        //     var cEvent = new lib_core.GuiEvent()
        //             .type( lib_core.GuiEvents.EDITOR_TRANSFORM_START )
        //             .fromJSEvent(event);

        //     self.stateMachine.handle(cEvent);

        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0)).on("transform", function(event) {
        //     var cEvent = new lib_core.GuiEvent()
        //             .type( lib_core.GuiEvents.EDITOR_TRANSFORM )
        //             .fromJSEvent(event);

        //     self.stateMachine.handle(cEvent);

        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0)).on("transformend", function(event) {
        //     var cEvent = new lib_core.GuiEvent()
        //             .type( lib_core.GuiEvents.EDITOR_TRANSFORM_END )
        //             .fromJSEvent(event);

        //     self.stateMachine.handle(cEvent);

        // });

    }else if ('ontouchstart' in document.documentElement) {

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("transformstart", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TRANSFORM_START)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("transform", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TRANSFORM)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("transformend", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TRANSFORM_END)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("dragstart", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TOUCH_PAN_START)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("drag", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TOUCH_PAN)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

        // Hammer(this.getTemplate().getCanvasEl().get(0),{"prevent_default":true}).on("dragend", function(event) {
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_TOUCH_PAN_END)
        //             .fromJSEvent(event);

        //     return self.stateMachine.handle(cEvent);
        // });

    }
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor2DView.prototype.onEditorMouseUp = function(event) {
    this.mousedown_flag = false;
    var mouseCoord = this.relativeMouseCoord(event);
    this.mouseCoord = mouseCoord;

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_MOUSE_UP)
            .fromJSEvent(event)
            .data( 'mouseCoord', mouseCoord )
            .scope(this.editorModel.scope());

    this.stateMachine.handle(cEvent);
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor2DView.prototype.onEditorMouseDown = function(event){
    this.mousedown_flag = true;
    var mouseCoord = this.relativeMouseCoord(event);
    this.mouseCoord = mouseCoord;

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_MOUSE_DOWN)
            .fromJSEvent(event)
            .data( 'mouseCoord', mouseCoord )
            .scope(this.editorModel.scope());

    this.stateMachine.handle(cEvent);
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor2DView.prototype.onEditorMouseMove = function(event){
    this.mouseCoord = this.relativeMouseCoord(event);

    // Track Cursor
    if (this.root.shareJsDoc && this.root.shareJsDoc.connection && this.root.shareJsDoc.connection.id && window["users"] > 0) {
        // Make sure we still exist in the doc and we are not too old
        var rec = this.root.shareJsDoc.at(["users", this.root.shareJsDoc.connection.id]).get();
        var d = new Date();
        d.setMinutes(d.getMinutes()-5);

        if (!rec || rec.last_active < d) {
            this.root.shareJsDoc.at(["users", this.root.shareJsDoc.connection.id]).set({'name': $(".username_holder").text(), 'last_active': Date.now()});
        }

        // Send my position around
        this.root.shareJsDoc.shout(JSON.stringify([this.root.shareJsDoc.connection.id, "mousePos", this.editorModel.toRealCoord(this.mouseCoord), this.editorModel.type()]));
    }

    // Inject event
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EDITOR_MOUSE_MOVE)
            .fromJSEvent(event)
            .data( 'mouseCoord', this.mouseCoord )
            .data('type', this.editorModel.type())
            .scope(this.editorModel.scope());

    this.stateMachine.handle(cEvent);

    // This is used to prevent dragging selection outside form fields
    var d2 = event.srcElement || event.target;
    if (d2.tagName.toUpperCase() === 'INPUT' || d2.tagName.toUpperCase() === 'TEXTAREA') {
        return true;
    } else {
        return false;
    }
};

/**
 * @param   {Object}    objEvent
 * @param   {number}    delta
 * @param   {number}    deltaX
 * @param   {number}    deltaY
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor2DView.prototype.onCanvasMouseWheel = function(objEvent, delta, deltaX, deltaY){
    this.mouseCoord = this.relativeMouseCoord(objEvent.originalEvent);

    var intDelta = (objEvent.shiftKey) ? -deltaX : deltaY ;
    if ( Math.abs(intDelta) >= 40 ) {
        intDelta /= 40;
    }

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CANVAS_MOUSE_WHEEL);
    cEvent
        .data( 'intDelta', intDelta )
        .data( 'mouseCoord', this.mouseCoord )
        .scope(this.editorModel.scope());

    return this.stateMachine.handle(cEvent);
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor2DView.prototype.onCanvasMouseUp = function(event) {
    this.mousedown_flag = false;
    var mouseCoord = this.relativeMouseCoord(event);
    this.mouseCoord = mouseCoord;

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CANVAS_MOUSE_UP)
            .fromJSEvent(event)
            .data( 'mouseCoord', mouseCoord )
            .scope(this.editorModel.scope());

    return this.stateMachine.handle(cEvent);
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {SchematicEditor}
 */
Editor2DView.prototype.onCanvasMouseDown = function(event){
    this.mousedown_flag = true;
    var mouseCoord = this.relativeMouseCoord(event);
    this.mouseCoord = mouseCoord;

    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CANVAS_MOUSE_DOWN)
            .fromJSEvent(event)
            .data( 'mouseCoord', mouseCoord )
            .scope(this.editorModel.scope());

    return this.stateMachine.handle(cEvent);
};

Editor2DView.prototype.getEditorSize = function() {

    return new lib_geometry.BoundingBox(
        this.getTemplate().getCanvasEl().offset().left,
        this.getTemplate().getCanvasEl().offset().top,
        this.getTemplate().getCanvasEl().width(),
        this.getTemplate().getCanvasEl().height()
    );
};


Editor2DView.prototype.setGroupInFocus = function(group) {
    this.groupInFocus = group;
};

Editor2DView.prototype.getGroupInFocus = function() {
    return this.groupInFocus;
};

Editor2DView.prototype.getGroupInfo = function(layerKey) {
    var self = this;
    var result = self.layers.get(layerKey);
    return result;
};

Editor2DView.prototype.emptyLayers = function() {
    var self = this;
    self.layers.forEach(function(index,layerInfo){
        $(layerInfo.svgGroup).empty();
    });
};

Editor2DView.prototype.createGroupInfos = function (layers) {
    var groups = new lib_core.Collections.HashMap();

    for (var i in layers) {
        groups.put(layers[i], new GroupInfo(
                    layers[i],
                    true,
                    layers[i],
                    null,
                    true,
                    true));
    }

    return groups;
};

Editor2DView.prototype.loadData = function () {
    this.rootGroup = new RootGroup(this, this.data, this);
    this.setGroupInFocus(this.rootGroup);
};

Editor2DView.prototype.getLayers = function() {
    var self = this;
    var layers = self.layers;
    return layers;
};

Editor2DView.prototype.relativeMouseCoord = function(event) {
    return this.editorModel.getRelativeMouseCoord(event);
};
